/**
 * FieldShell — label + optional required-asterisk wrapper for form controls.
 *
 * Same pattern Flutter `FieldAndLabel` ships across the app — a label above
 * the control with `*` if mandatory. Pulled out of the reports filters block
 * because the Summary section + every filter control needs the same shape;
 * lifting it here lets Patients / Billing forms reuse it without redefining
 * the markup.
 */

interface FieldShellProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FieldShell({ label, required, children }: FieldShellProps) {
  return (
    <label className="block">
      <span className="block text-sm font-medium text-text-secondary mb-1">
        {label}
        {required && <span className="text-status-error ml-1">*</span>}
      </span>
      {children}
    </label>
  );
}
